// extracted by mini-css-extract-plugin
module.exports = {"carousel":"_Carousel_carousel__2WwEe","icon":"_Carousel_icon__l8B2Y","navControl":"_Carousel_navControl__3-rHL"};